<script lang="ts">
import { computed, defineComponent, h, toRefs, unref } from 'vue';

import { classNames } from '@components/utils';

import { makeDisabledProps, makeThemeProps, provideTheme, useRender } from '../../composable';
import { CdsTabs } from '../CdsTabs';

import type { PropType } from 'vue';

export const ITEM_HEIGHT = 32;
export const componentName = 'CdsContentSwitcher';
export default defineComponent({
  name: componentName,
  props: {
    /**
     * Значение v-model
     */
    modelValue: {
      type: null,
      default: undefined
    },
    /**
     * Занимать все доступное пространство
     */
    grow: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    ...makeDisabledProps(),
    ...makeThemeProps()
  },
  emits: {
    /**
     * Событие изменения v-model
     * @type { boolean }
     */
    'update:modelValue': (value: unknown) => true
  },
  setup(props, { slots, emit }) {
    const { themeClasses } = provideTheme(props);
    const { modelValue } = toRefs(props);

    const classes = computed(() => ({
      'cds-content-switcher--grow': props.grow
    }));

    useRender(() => {
      return h(
        CdsTabs,
        {
          modelValue: unref(modelValue),
          disabled: props.disabled,
          height: ITEM_HEIGHT,
          grow: props.grow,
          class: classNames('cds-content-switcher', unref(themeClasses), unref(classes)),
          'onUpdate:modelValue': (value: unknown) => {
            emit('update:modelValue', value);
          }
        },
        () => slots.default?.()
      );
    });
    return {};
  }
});
</script>

<style lang="scss">
@import './CdsContentSwitcher';
</style>
